"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    renderTab_unstable: function() {
        return _Tab.renderTab_unstable;
    },
    Tab: function() {
        return _Tab.Tab;
    },
    tabClassNames: function() {
        return _Tab.tabClassNames;
    },
    useTabStyles_unstable: function() {
        return _Tab.useTabStyles_unstable;
    },
    useTab_unstable: function() {
        return _Tab.useTab_unstable;
    },
    renderTabList_unstable: function() {
        return _TabList.renderTabList_unstable;
    },
    TabList: function() {
        return _TabList.TabList;
    },
    TabListProvider: function() {
        return _TabList.TabListProvider;
    },
    tabListClassNames: function() {
        return _TabList.tabListClassNames;
    },
    useTabListContext_unstable: function() {
        return _TabList.useTabListContext_unstable;
    },
    useTabListContextValues_unstable: function() {
        return _TabList.useTabListContextValues_unstable;
    },
    useTabListStyles_unstable: function() {
        return _TabList.useTabListStyles_unstable;
    },
    useTabList_unstable: function() {
        return _TabList.useTabList_unstable;
    }
});
const _Tab = require("./Tab");
const _TabList = require("./TabList");
